// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3PObM","resendInfoText":"OnGoingPaymentBox_resendInfoText__10pXe"};